import React from 'react';

import Loadable from 'react-loadable';
import Loading from './common_components/Loading';

const AsyncMain = Loadable({
  loader: () => import('./pitch_components/Main'),
  loading: Loading,
});

export default class PitchApp extends React.Component {
  render() {
    return <AsyncMain {...this.props} />;
  }
}
